import { Directive, ElementRef, HostListener, HostBinding, Input, Output, Renderer, EventEmitter, AfterContentInit } from '@angular/core';
import { Size } from '../Classes/sizeClass.class';

@Directive({
    selector: 'sizable'

})

export class SizableDirective implements AfterContentInit {

    mouseIsDown: boolean = false;
    mouseIsOver: boolean = false;
    hasHandle: boolean = false;
    xPos: number;
    elementSize: Size;
    movements: number[] = [];

    @Input() displayWidth: number = 10;
    @Output() resized = new EventEmitter<void>();

    constructor(private renderer: Renderer, private el: ElementRef) {
    }

    private isNumberCloseTo(value1: number, value2: number, precision: number = 7): boolean {
        var diff: number = Math.abs(value1 - value2);
        return diff < precision;
    };

    isWithinBoundingY(mouseY): boolean {
        return (this.elementSize.top + mouseY) >= this.elementSize.top && mouseY <= this.elementSize.bottom;
    }

    private isOverEdge(mousex: number, mousey: number): boolean {

        if (this.isNumberCloseTo(mousex, this.elementSize.right) && this.isWithinBoundingY(mousey)) {
            this.hasHandle = true;
            return true;
        }
        this.hasHandle = false;
        return false;
    }

    processMovements(): void {
        if (this.movements.length > 1) {
            return;
        }

        let move = () => {
            var amount = this.movements.shift();
            if (amount) {
                this.width = this.elementSize.width + amount;
                move();
            }
        }
        move();
    }

    @HostBinding('style.width.px')
    width: number;

    @HostListener('window:mousedown', ['$event'])
    onMousedown(event: MouseEvent) {
        if (this.hasHandle) {
            window.getSelection().removeAllRanges();
            this.mouseIsDown = true;
            this.xPos = event.clientX;
            this.movements.length = 0;
        }
    }

    @HostListener('window:mousemove', ['$event'])
    onMousemove(event: MouseEvent) {

        //if (!this.mouseIsOver) {
        //    return;
        //}

        if (this.mouseIsDown) {
            var movement = event.clientX - this.xPos;
            this.movements.push(movement);
            this.processMovements();
            event.preventDefault();
            this.resized.emit();
            return;
        }

        if (this.isOverEdge(event.x, event.y)) {
            this.renderer.setElementStyle(this.el.nativeElement, 'cursor', 'ew-resize');
            // this.renderer.setElementStyle(this.el.nativeElement, 'border-right-style', 'dotted');
        } else {
            this.renderer.setElementStyle(this.el.nativeElement, 'cursor', 'auto');
            // this.renderer.setElementStyle(this.el.nativeElement, 'border-right-style', 'solid');
        }
    }

    @HostListener('window:mouseup', ['$event'])
    onMouseup(event: MouseEvent) {
        this.mouseIsDown = false;
        this.getRect();
        this.resized.emit();
    }

    @HostListener('mouseleave', ['$event'])
    onMouseLeave(event: MouseEvent) {
        this.mouseIsOver = false;
    }

    @HostListener('mouseover', ['$event'])
    onMouseOver(event: MouseEvent) {
        this.mouseIsOver = true;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.getRect();
    }

    ngAfterContentInit(): void {
        this.getRect();
    }

    getRect() {
        var rect = this.el.nativeElement.getBoundingClientRect();
        this.elementSize = new Size(
            rect.left,
            rect.top,
            rect.width,
            rect.height
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/sizable.directive.ts